<template>
  <!-- 窗型 -->
  <div>
    <div style="height:100px;padding-top:20px" @click="tapTop">
      <img style="display:block;width:60px;height:60px;margin:0 auto" src="../../static/image/top.png" alt />
    </div>
    <div class="calligraphy" style="height:600px;overflow: hidden;">
      <!-- <div v-dragscroll> -->
      <div class="calligraphy-page" v-show="this.$store.state.flage" v-if="flage" :style="{position:'relative',top:Top+'px'}" >
        <div style="height: 229px;overflow:scroll" v-for="(item,id) in $store.state.calligarr" :key="id" class="ncativ" >
          <div :class="id==number?'active':''" @click="callInfo(item,id)"></div>
          <div :class="classNum==1?'imgurl':'imgUrl'">
            <img :src="item.url" @click="callInfo(item,id)" alt />
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div style="height:80px;padding-top:20px" @click="tapDown">
      <img style="display:block;width:60px;height:60px;margin:0 auto" src="../../static/image/down.png" alt />
    </div>
  </div>
</template>
<script>
import Bus from "../../bus/bus";
import { Message } from "element-ui";
export default {
  props: ["tabNumber"],
  data() {
    return {
      calligarr: [],
      number: 1000,
      flage: true,
      Top: 0,
      startPoint: "",
      classNum:1
    };
  },
  created() {
    //   初始化vuex数据   窗型默认展示
    console.log(".............................");
    // console.log(this.tabNumber)
    this.$store.state.calligarr.forEach(item => {
      console.log(item.type)
      if(item.type == 'color'){
        this.classNum = 1
      }else{
        this.classNum = 2
      }
      item.url = require("../../static/image/" + item.url);
    });
  },
  mounted() {
    Bus.$on("tabNumber", function() {
      this.number = 1000;
    });
  },
  methods: {
    swipeup(){
      console.log('花花花')
    },
    callInfo(item, id) {
      this.number = id;
      // console.log(item);
      this.$store.dispatch("classTab", item);
    },
    tapTop() {
      if (this.Top == 0) {
        Message.success({ message: "已经到头部了!" });
        this.Top = 0;
        return false;
      } else {
        this.Top = this.Top -= -100;
        // console.log(this.Top);
        if(this.Top>0){
          console.log('123')
          this.Top = 0;
        }
      }
    },
    tapDown() {
      var calligraphy=document.getElementsByClassName('calligraphy')[0].clientHeight
      var tet=document.getElementsByClassName('calligraphy-page')[0].clientHeight
      if (this.Top == -tet+600) {
        Message.success({ message: "已经到底了!" });
        this.Top = -tet+600;
        return false;
      } else if(tet<calligraphy){
        Message.success({ message: "已经到底了!" });
      }else {
        this.Top = this.Top += -100;
        // console.log(this.Top);
        if(this.Top<-tet+600){
          console.log('123')
          this.Top = -tet+600;
        }
      }
    },
  }
};
</script>

<style>
.calligraphy-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.calligraphy-page .ncativ {
  flex: 1;
  position: relative;
}
.calligraphy-page .active {
  width: 60px;
  height: 60px;
  position: absolute;
  left: 33%;
  top: 3vh;
  background: url("../../static/image/xuanze.png") no-repeat;
  background-size: 100% 100%;
  opacity: 0.8;
}
.calligraphy-page .ncativ {
  width: 100%;
  height: 100%;
}
.calligraphy-page .ncativ .imgUrl {
  width: 180px;
  height: auto;
  margin: 0 auto;
}
.calligraphy-page .ncativ .imgurl {
  width: 120px;
  height: auto;
  margin: 0 auto;
}
.calligraphy-page .ncativ .imgUrl img {
  width: 100%;
  height: 100%;
}
.calligraphy-page .ncativ .imgurl img {
  width: 100%;
  height: 100%;
}
._v-container {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
div::-webkit-scrollbar {
  width: 0;
}
</style>